import { render, staticRenderFns } from "./AutocompleteDataEstados.vue?vue&type=template&id=8b1bdd42"
import script from "./AutocompleteDataEstados.vue?vue&type=script&lang=js"
export * from "./AutocompleteDataEstados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports